// 曲拉收购可视化平台
<template>
  <div class="subpage ganzi qula-acquisition" :style="rootVars">
    <div class="qa-header">
      <div class="qa-title">
        <h1>{{ $C('qulaAcquisition','mainTitle','曲拉收购可视化数据实时监控评测分析') }}</h1>
        <p class="qa-time">{{currentTime}}</p>
      </div>
    </div>
    <div class="flx-bs container">
      <!-- 左侧 -->
      <div class="left qa-left">
        <div class="part qa-part">
          <div class="head">
            <span class="title"><i class="icon icon-tb"></i>{{ $C('qulaAcquisition','blockTitleHistory','历史收购订单数据') }}</span>
          </div>
          <div class="qa-table-wrap">
            <table class="qa-table">
              <thead>
                <tr>
                  <th>{{ $C('qulaAcquisition','thYear','年份') }}</th>
                  <th>{{ $C('qulaAcquisition','thTons','吨数（吨）') }}</th>
                  <th>{{ $C('qulaAcquisition','thAmount','金额（万元）') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in yearStats" :key="idx">
                  <td>{{item.year}}</td>
                  <td class="qa-num">{{item.tons}}</td>
                  <td class="qa-num">{{item.amount}}</td>
                </tr>
                <tr v-if="!yearStats.length">
                  <td colspan="3" class="qa-empty">{{ordersLoading ? this.$C('qulaAcquisition','emptyLoading','数据加载中…') : (ordersError || this.$C('qulaAcquisition','emptyOrders','暂无订单数据'))}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="part qa-part">
          <div class="head">
            <span class="title"><i class="icon icon-tb"></i>{{ $C('qulaAcquisition','blockTitleRegion','收购地域月、年订单数量（户）') }}</span>
          </div>
          <div class="qa-table-wrap">
            <table class="qa-table">
              <thead>
                <tr>
                  <th>{{ $C('qulaAcquisition','thArea','地域') }}</th>
                  <th>{{ $C('qulaAcquisition','thMonthOrders','月订单') }}</th>
                  <th>{{ $C('qulaAcquisition','thYearOrders','年订单') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in regionStats" :key="idx">
                  <td>{{item.area}}</td>
                  <td class="qa-num">{{item.monthOrders}}</td>
                  <td class="qa-num">{{item.yearOrders}}</td>
                </tr>
                <tr v-if="!regionStats.length">
                  <td colspan="3" class="qa-empty">{{ordersLoading ? this.$C('qulaAcquisition','emptyLoading','数据加载中…') : (ordersError || this.$C('qulaAcquisition','emptyOrders','暂无订单数据'))}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 中间 -->
      <div class="middle qa-middle">
        <div class="part qa-part qa-map-part">
          <div class="qa-map" id="qulaMap"></div>
        </div>
      </div>

      <!-- 右侧 -->
      <div class="right qa-right">
        <div class="part qa-part qa-farmer">
          <div class="head flx-bc">
            <span class="title"><i class="icon icon-tb"></i>{{ $C('qulaAcquisition','blockTitleFarmer','农户交货统计') }}</span>
            <div class="btns flx-lc">
              <span :class="farmerActive===1?'active':''" @click="farmerActive=1">{{ $C('qulaAcquisition','tabMonth','月数据') }}</span>
              <span :class="farmerActive===2?'active':''" @click="farmerActive=2">{{ $C('qulaAcquisition','tabYear','年数据') }}</span>
              <span :class="farmerActive===3?'active':''" @click="farmerActive=3">{{ $C('qulaAcquisition','tabAll','历史总计') }}</span>
            </div>
          </div>
          <div class="qa-table-wrap qa-farmer-wrap">
            <table class="qa-table qa-farmer-table">
              <thead>
                <tr>
                  <th>{{ $C('qulaAcquisition','thFarmer','农户') }}</th>
                  <th>{{ $C('qulaAcquisition','thQty','交货数量') }}</th>
                  <th>{{ $C('qulaAcquisition','thCount','交货次数') }}</th>
                  <th>{{ $C('qulaAcquisition','thDetail','明细') }}</th>
                  <th>{{ $C('qulaAcquisition','thPhoto','订单图片') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(f, idx) in farmerList" :key="idx">
                  <td class="qa-fname">{{f.name}}</td>
                  <td class="qa-qty">{{formatQty(f.total)}}{{ $C('qulaAcquisition','qtyUnit',' kg') }}</td>
                  <td>{{f.count}}</td>
                  <td><span class="qa-link" @click="openDetail(f)">{{ $C('qulaAcquisition','detailLink','查看') }}</span></td>
                  <td>
                    <img v-if="f.photoId" class="qa-thumb" :src="photoUrl(f.photoId)" :alt="f.name" @click="openLightbox(photoUrl(f.photoId))" />
                    <span v-else class="qa-noimg">—</span>
                  </td>
                </tr>
                <tr v-if="!farmerList.length">
                  <td colspan="5" class="qa-empty">{{ordersLoading ? this.$C('qulaAcquisition','emptyLoading','数据加载中…') : (ordersError || this.$C('qulaAcquisition','emptyFarmer','暂无交货数据'))}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="qa-summary">
            <span>{{ $C('qulaAcquisition','summaryFarmers','农户数：') }}{{summary.farmers}}</span>
            <span>{{ $C('qulaAcquisition','summaryQty','交货数量：') }}{{formatQty(summary.quantity)}}{{ $C('qulaAcquisition','qtyUnit',' kg') }}</span>
          </div>
        </div>

        <div class="part qa-part qa-heavy">
          <div class="head">
            <span class="title"><i class="icon icon-tb"></i>{{ $C('qulaAcquisition','blockTitleHeavy','年交纳曲拉200kg（含）以上农户统计') }}</span>
          </div>
          <div class="qa-table-wrap">
            <table class="qa-table">
              <thead>
                <tr>
                  <th>{{ $C('qulaAcquisition','thHeavyArea','地域') }}</th>
                  <th>{{ $C('qulaAcquisition','thHeavyCount','农户数') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in heavyFarmers" :key="idx">
                  <td>{{item.area}}</td>
                  <td class="qa-num">{{item.count}}</td>
                </tr>
                <tr v-if="!heavyFarmers.length">
                  <td colspan="2" class="qa-empty">{{ordersLoading ? this.$C('qulaAcquisition','emptyLoading','数据加载中…') : (ordersError || this.$C('qulaAcquisition','emptyHeavy','暂无符合条件农户'))}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="qa-summary">
            <span>{{ $C('qulaAcquisition','heavySummaryFarmers','符合农户：') }}{{heavyTotal.farmers}}{{ $C('qulaAcquisition','heavyUnit',' 户') }}</span>
            <span>{{ $C('qulaAcquisition','heavySummaryQty','对应交货：') }}{{formatQty(heavyTotal.quantity)}}{{ $C('qulaAcquisition','qtyUnit',' kg') }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 农户交货明细弹层 -->
    <div class="qa-modal-mask" v-if="farmerModal" @click.self="closeDetail">
      <div class="qa-modal">
        <div class="qa-modal-head">
          <span class="qa-modal-title">{{farmerModal.name}}{{ $C('qulaAcquisition','modalTitlePre','· 交货明细（') }}{{farmerModal.count}}{{ $C('qulaAcquisition','modalTitleMid',' 次 / 共 ') }}{{formatQty(farmerModal.total)}}{{ $C('qulaAcquisition','modalTitleSuf',' kg）') }}</span>
          <span class="qa-close" @click="closeDetail">×</span>
        </div>
        <div class="qa-modal-body">
          <table class="qa-detail-table">
            <thead>
              <tr>
                <th>{{ $C('qulaAcquisition','modalThOrder','订单编号') }}</th>
                <th>{{ $C('qulaAcquisition','modalThCategory','品类') }}</th>
                <th>{{ $C('qulaAcquisition','modalThQty','数量(kg)') }}</th>
                <th>{{ $C('qulaAcquisition','modalThTime','时间') }}</th>
                <th>{{ $C('qulaAcquisition','modalThStatus','状态') }}</th>
                <th>{{ $C('qulaAcquisition','modalThAddr','收货地址') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(o, i) in farmerModal.orders" :key="i">
                <td class="qa-nowrap">{{o.orderNum}}</td>
                <td>{{o.categoryName}}</td>
                <td class="qa-nowrap">{{formatQty(o.goodsNum)}}</td>
                <td class="qa-nowrap">{{o.createTime}}</td>
                <td>{{statusText(o.status)}}</td>
                <td class="qa-addr">{{o.receiveAddress}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 订单图片全屏灯箱 -->
    <div class="qa-lightbox" v-if="lightboxImg" @click="closeLightbox">
      <img :src="lightboxImg" :alt="$C('qulaAcquisition','lightboxAlt','订单图片')" />
      <span class="qa-lightbox-close" @click="closeLightbox">×</span>
      <span class="qa-lightbox-tip">{{ $C('qulaAcquisition','lightboxTip','点击任意处关闭') }}</span>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import 'echarts/map/js/china'
import { mediaUrl } from '@/cms/config'

// 曲拉收购单价（元/kg）：后台订单接口无金额字段，"历史收购订单数据"的金额按此单价折算
const QULA_UNIT_PRICE = 6.8

// 地图各省收购量（吨）：静态展示数据，后台可在「曲拉收购可视化 → 地图（数据指标）→ mapData」编辑
const QULA_MAP_DATA = [
  { name: '四川', value: 218 },
  { name: '甘肃', value: 120 },
  { name: '青海', value: 52 },
  { name: '西藏', value: 42 },
  { name: '云南', value: 35 },
]

export default {
  name: 'QulaAcquisition',
  data() {
    return {
      currentTime: '',
      timer: null,
      farmerActive: 1,
      orders: [],
      ordersLoading: true,
      ordersError: '',
      farmerModal: null,
      lightboxImg: '',
      mapChart: null
    };
  },
  computed: {
    baseApi() {
      return (process.env.BASE_URL || '/') + 'wx-api/'
    },
    refPeriod() {
      // 以数据中最新的订单时间为“当前月/年”基准，保证三个页签始终有内容
      let max = ''
      this.orders.forEach(o => { if (o.createTime > max) max = o.createTime })
      return { month: max.slice(0, 7), year: max.slice(0, 4) }
    },
    filteredOrders() {
      if (!this.orders.length) return []
      if (this.farmerActive === 3) return this.orders
      const key = this.farmerActive === 1 ? this.refPeriod.month : this.refPeriod.year
      return this.orders.filter(o => (o.createTime || '').slice(0, key.length) === key)
    },
    farmerList() {
      const map = {}
      this.filteredOrders.forEach(o => {
        const name = o.receiveName || this.$C('qulaAcquisition', 'unknownFarmer', '未知农户')
        if (!map[name]) map[name] = { name, total: 0, count: 0, orders: [], photoId: null }
        map[name].total += Number(o.goodsNum) || 0
        map[name].count += 1
        map[name].orders.push({
          orderNum: o.orderNum,
          categoryName: o.categoryName,
          goodsNum: o.goodsNum,
          createTime: o.createTime,
          status: o.status,
          receiveAddress: o.receiveAddress
        })
        if (!map[name].photoId && o.photoId) map[name].photoId = o.photoId
      })
      // 按累计交货数量降序
      return Object.values(map).sort((a, b) => b.total - a.total)
    },
    summary() {
      const list = this.farmerList
      const quantity = list.reduce((sum, f) => sum + Number(f.total), 0)
      return { farmers: list.length, quantity: quantity }
    },
    // 历史收购订单数据：按年份聚合吨数与金额（后台订单无金额字段，按 QULA_UNIT_PRICE 折算）
    yearStats() {
      const map = {}
      this.orders.forEach(o => {
        const y = (o.createTime || '').slice(0, 4)
        if (!y) return
        if (!map[y]) map[y] = { year: y, kg: 0 }
        map[y].kg += Number(o.goodsNum) || 0
      })
      return Object.values(map)
        .map(it => ({
          year: it.year + ' 年',
          tons: (it.kg / 1000).toFixed(1),
          amount: (it.kg * QULA_UNIT_PRICE / 10000).toFixed(1)
        }))
        .sort((a, b) => b.year.localeCompare(a.year))
    },
    // 收购地域月、年订单数量（户）：按县聚合，月/年以数据最新订单时间为基准（与右侧页签口径一致）
    regionStats() {
      const month = this.refPeriod.month
      const year = this.refPeriod.year
      const map = {}
      this.orders.forEach(o => {
        const area = this.regionOf(o)
        if (!map[area]) map[area] = { area, monthOrders: 0, yearOrders: 0 }
        const t = o.createTime || ''
        if (t.slice(0, 4) === year) {
          map[area].yearOrders++
          if (t.slice(0, 7) === month) map[area].monthOrders++
        }
      })
      return Object.values(map).sort((a, b) => b.yearOrders - a.yearOrders)
    },
    // 年交纳曲拉 200kg（含）以上农户：先按农户聚合年交货量，达标后按地域计户数
    heavyFarmers() {
      const year = this.refPeriod.year
      const perFarmer = {}
      this.orders.forEach(o => {
        if ((o.createTime || '').slice(0, 4) !== year) return
        const key = o.receiveName || '未知农户'
        if (!perFarmer[key]) perFarmer[key] = { area: this.regionOf(o), kg: 0 }
        perFarmer[key].kg += Number(o.goodsNum) || 0
      })
      const byArea = {}
      Object.values(perFarmer).forEach(f => {
        if (f.kg < 200) return
        if (!byArea[f.area]) byArea[f.area] = { area: f.area, count: 0, kg: 0 }
        byArea[f.area].count++
        byArea[f.area].kg += f.kg
      })
      return Object.values(byArea).sort((a, b) => b.count - a.count)
    },
    heavyTotal() {
      const farmers = this.heavyFarmers.reduce((s, it) => s + it.count, 0)
      const quantity = this.heavyFarmers.reduce((s, it) => s + it.kg, 0)
      return { farmers, quantity }
    },
    // 可选页面背景图：后台「曲拉收购可视化 → 图片与视频 → pageBg」配置后覆盖默认主题背景；
    // 未配置时返回空对象，沿用全局看板主题背景，页面外观保持不变
    rootVars() {
      const bg = this.$C('qulaAcquisition', 'pageBg', '')
      return bg ? { '--page-bg': `url("${mediaUrl(bg)}") center/cover no-repeat` } : {}
    }
  },
  mounted() {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
    this.fetchOrders()
    this.$nextTick(() => {
      this.initMap()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
    window.removeEventListener('resize', this.handleResize)
    if (this.mapChart) {
      this.mapChart.dispose()
      this.mapChart = null
    }
  },
  watch: {
    '$route.path': {
      handler(path) {
        if (path === '/qula-acquisition') {
          this.$nextTick(() => {
            this.initMap()
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    updateTime() {
      const now = new Date()
      const pad = n => String(n).padStart(2, '0')
      this.currentTime = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
    },
    handleResize() {
      if (this.mapChart) this.mapChart.resize()
    },
    photoUrl(id) {
      return this.baseApi + 'sysFileInfo/preview?id=' + id
    },
    formatQty(v) {
      const n = Number(v)
      if (!isFinite(n)) return v
      return n.toFixed(1)
    },
    // 地域归属：优先订单的 county 字段，缺失时从收货地址解析"xx县"（剥离省/州前缀），兜底"其他"
    regionOf(o) {
      if (o.county) return o.county
      const m = (o.receiveAddress || '').match(/([\u4e00-\u9fa5]{2,7}县)/)
      if (!m) return this.$C('qulaAcquisition', 'regionOther', '其他')
      let name = m[1]
      if (name.includes('州')) name = name.slice(name.lastIndexOf('州') + 1)
      if (name.includes('省')) name = name.slice(name.lastIndexOf('省') + 1)
      return name
    },
    statusText(s) {
      const m = {
        1: this.$C('qulaAcquisition', 'statusNormal', '正常'),
        2: this.$C('qulaAcquisition', 'statusDisabled', '停用'),
        3: this.$C('qulaAcquisition', 'statusVoid', '作废'),
      }
      return m[s] != null ? m[s] : ('状态' + s)
    },
    async fetchOrders() {
      this.ordersLoading = true
      this.ordersError = ''
      try {
        const all = []
        let pageNo = 1
        const pageSize = 200
        while (true) {
          const res = await fetch(this.baseApi + 'order/page?pageNo=' + pageNo + '&pageSize=' + pageSize)
          const json = await res.json()
          if (!json.success) { this.ordersError = (json.message || '获取订单失败') + '（请检查 dev 代理 token 是否有效）'; break }
          const rows = (json.data && json.data.rows) || []
          all.push.apply(all, rows)
          if (all.length >= json.data.totalRows || rows.length === 0) break
          pageNo++
        }
        this.orders = all.map(o => {
          const goods = (o.goodsList || []).find(g => g.type === 1) || (o.goodsList || [])[0]
          const photoId = goods && goods.photoUrl ? (goods.photoUrl.match(/id=([\w-]+)/) || [])[1] : null
          return {
            orderNum: o.orderNum,
            categoryName: o.categoryName,
            goodsNum: o.goodsNum,
            createTime: o.createTime,
            status: o.status,
            receiveAddress: o.receiveAddress,
            receiveName: o.receiveName,
            photoId: photoId
          }
        })
      } catch (e) {
        this.ordersError = '网络请求失败：' + e.message
      } finally {
        this.ordersLoading = false
      }
    },
    openDetail(f) {
      this.farmerModal = f
    },
    closeDetail() {
      this.farmerModal = null
    },
    openLightbox(url) {
      this.lightboxImg = url
    },
    closeLightbox() {
      this.lightboxImg = null
    },
    initMap() {
      try {
        console.log('initMap called, echarts=', typeof echarts, 'dom=', !!document.getElementById('qulaMap'))
        const dom = document.getElementById('qulaMap')
        if (!dom) {
          console.warn('qulaMap dom not found')
          return
        }
        console.log('qulaMap size:', dom.clientWidth, dom.clientHeight)
        if (this.mapChart) {
          this.mapChart.dispose()
        }
        this.mapChart = echarts.init(dom)
        const mapData = this.$CList('qulaAcquisition', 'mapData', QULA_MAP_DATA)
        const highlightNames = new Set(['四川', '甘肃', '青海', '西藏'])

        const valueMap = {}
        mapData.forEach(d => { valueMap[d.name] = d.value })

        const option = {
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              const v = Array.isArray(params.value) ? params.value[2] : params.value
              return params.name + '<br/>' + this.$C('qulaAcquisition', 'mapTooltipLabel', '曲拉收购量：') + (v || '-') + this.$C('qulaAcquisition', 'mapTooltipUnit', ' 吨')
            }
          },
          geo: {
            map: 'china',
            roam: true,
            zoom: 1.05,
            aspectScale: 0.75,
            layoutCenter: ['50%', '55%'],
            layoutSize: '95%',
            label: {
              show: true,
              color: '#a6c7e7',
              fontSize: 32,
              formatter: function (params) {
                if (highlightNames.has(params.name)) {
                  return '{box|' + params.name + ' ' + valueMap[params.name] + '}\n{arrow|▼}'
                }
                return params.name
              },
              rich: {
                box: {
                  color: '#fff',
                  fontSize: 34,
                  fontWeight: 700,
                  backgroundColor: 'rgba(0, 0, 0, 0.65)',
                  borderColor: '#F9B841',
                  borderWidth: 1,
                  borderRadius: 6,
                  padding: [6, 12],
                  align: 'center'
                },
                arrow: {
                  color: '#F9B841',
                  fontSize: 18,
                  align: 'center',
                  lineHeight: 14
                }
              }
            },
            itemStyle: {
              areaColor: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  { offset: 0, color: '#1a5fb4' },
                  { offset: 1, color: '#0c2d63' }
                ]
              },
              borderColor: '#36d1ff',
              borderWidth: 1,
              shadowColor: 'rgba(0, 0, 0, 0.45)',
              shadowBlur: 12,
              shadowOffsetX: 0,
              shadowOffsetY: 8
            },
            emphasis: {
              label: { color: '#fff' },
              itemStyle: {
                areaColor: '#F9B841',
                shadowColor: 'rgba(249, 184, 65, 0.5)',
                shadowBlur: 16
              }
            }
          },
          series: [
            {
              name: this.$C('qulaAcquisition', 'mapSeriesName', '曲拉收购量'),
              type: 'map',
              geoIndex: 0,
              data: mapData
            }
          ]
        }
        this.mapChart.setOption(option)
        console.log('map setOption done')
      } catch (err) {
        console.error('initMap error:', err.message, err.stack)
      }
    }
  }
};
</script>

<style scoped lang="less">
.qula-acquisition{
    .container{
        height: calc(100% - var(--screen-margin, 219px));
        align-items: stretch;
        .left{ width: 23%; }
        .middle{
            width: 50%;
            display: flex;
            flex-direction: column;
            margin: 0 30px;
            height: 100%;
        }
        .right{ width: 23%; }
    }
    .qa-header{
        position: absolute;
        top: 40px;
        right: 200px;
        z-index: 1000;
        text-align: right;
        .qa-title{
            display: inline-block;
            text-align: right;
            h1{
                font-size: 52px;
                font-weight: 800;
                color: #00f6ff;
                letter-spacing: 4px;
                text-shadow: 0 0 30px rgba(0,246,255,.35);
                margin: 0;
                line-height: 1.1;
            }
            .qa-time{
                font-size: 28px;
                color: #8bc4ff;
                margin: 8px 0 0;
                letter-spacing: 2px;
            }
        }
    }
    .qa-left, .qa-right{
        display: flex;
        flex-direction: column;
        gap: 30px;
        min-height: 0;
        overflow: hidden;
    }
    .qa-part{
        flex: 1 1 auto;
        min-height: 0;
        background: rgba(12, 36, 82, .55);
        border: 2px solid rgba(44, 156, 240, .35);
        border-radius: 16px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        .head{
            flex: 0 0 auto;
            height: auto;
            line-height: 1.4;
            margin-bottom: 20px;
            background: none;
            padding-right: 0;
            .title{
                font-size: 38px;
                font-weight: 700;
                color: #fff;
                background: none;
                padding-left: 0;
                margin-right: 0;
                &::after{ display: none; }
                i{ margin-right: 12px; color: #00f6ff; }
            }
            .btns span{
                width: 130px;
                height: 56px;
                line-height: 56px;
                font-size: 28px;
                cursor: pointer;
            }
        }
    }
    .qa-table-wrap{
        flex: 1 1 auto;
        min-height: 0;
        overflow: auto;
        &::-webkit-scrollbar{ width: 6px; }
        &::-webkit-scrollbar-thumb{ background: rgba(44,156,240,.4); border-radius: 3px; }
    }
    .qa-table{
        width: 100%;
        border-collapse: collapse;
        font-size: 32px;
        color: rgba(255,255,255,.9);
        th, td{
            padding: 16px 10px;
            text-align: center;
            border-bottom: 1px solid rgba(44,156,240,.25);
            white-space: nowrap;
        }
        th{
            background: rgba(15, 81, 176, .7);
            color: #00f6ff;
            font-weight: 700;
            position: sticky;
            top: 0;
        }
        tr:nth-child(even) td{ background: rgba(255,255,255,.04); }
        tr:hover td{ background: rgba(44,156,240,.15); }
    }
    .qa-num{ color: #00f6ff; font-weight: 700; }
    .qa-empty{ padding: 30px; color: rgba(255,255,255,.6); }
    .qa-summary{
        flex: 0 0 auto;
        margin-top: 14px;
        padding-top: 14px;
        border-top: 1px solid rgba(44,156,240,.25);
        font-size: 30px;
        color: #8bc4ff;
        display: flex;
        justify-content: space-between;
        span{ color: #00f6ff; font-weight: 700; }
    }
    .qa-farmer{
        flex: 3 1 0;
        min-height: 0;
        overflow: hidden;
        .head{
            margin-bottom: 14px;
            .title{ font-size: 40px; }
            .btns span{ font-size: 32px; }
        }
        .qa-table{
            font-size: 36px;
            th, td{ padding: 12px 10px; }
        }
        .qa-summary{
            font-size: 34px;
            margin-top: 10px;
            padding-top: 10px;
        }
    }
    .qa-map-part{
        flex: 1;
        min-height: 0;
        background: transparent;
        border: none;
        padding: 10px 0 0;
        .qa-map{
            flex: 1;
            min-height: 0;
            width: 100%;
        }
    }
    .qa-heavy{
        flex: 2 1 0;
        min-height: 0;
        overflow: hidden;
        .title{ font-size: 34px; }
        .qa-table{ font-size: 34px; }
    }
    .qa-farmer-table{
        table-layout: fixed;
        th, td{ padding: 12px 8px; }
        .qa-fname{ text-align: left; padding-left: 16px; }
        .qa-qty{ color: #00f6ff; font-weight: 700; }
        .qa-link{
            color: #00f6ff;
            cursor: pointer;
            text-decoration: underline dotted rgba(0,246,255,.5);
            &:hover{ color: #fff; }
        }
        .qa-thumb{
            width: 96px;
            height: 66px;
            object-fit: cover;
            border-radius: 6px;
            border: 1px solid rgba(44,156,240,.6);
            cursor: zoom-in;
            vertical-align: middle;
            transition: transform .15s;
            &:hover{ transform: scale(1.08); border-color: #00f6ff; }
        }
        .qa-noimg{ color: rgba(255,255,255,.4); }
        .qa-empty{ padding: 30px; color: rgba(255,255,255,.6); }
    }
    /* 农户交货明细弹层 */
    .qa-modal-mask{
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,.6);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .qa-modal{
        width: 72%;
        max-width: 2600px;
        max-height: 88%;
        background: rgba(8,28,64,.97);
        border: 2px solid #2C9CF0;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0,0,0,.6);
    }
    .qa-modal-head{
        flex: 0 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 32px;
        border-bottom: 1px solid rgba(44,156,240,.3);
    }
    .qa-modal-title{ font-size: 36px; font-weight: 700; color: #00f6ff; }
    .qa-close{ font-size: 50px; color: #8bc4ff; cursor: pointer; line-height: 1; &:hover{ color: #fff; } }
    .qa-modal-body{ flex: 1 1 auto; padding: 20px 32px 32px; overflow: auto; }
    .qa-detail-table{
        width: 100%;
        border-collapse: collapse;
        font-size: 30px;
        color: rgba(255,255,255,.92);
        th, td{ padding: 16px 16px; border-bottom: 1px solid rgba(44,156,240,.25); text-align: left; }
        th{ background: rgba(15,81,176,.7); color: #00f6ff; font-weight: 700; position: sticky; top: 0; }
        tr:nth-child(even) td{ background: rgba(255,255,255,.04); }
        .qa-nowrap{ white-space: nowrap; }
        .qa-addr{ white-space: normal; line-height: 1.35; max-width: 640px; }
    }
    /* 订单图片全屏灯箱 */
    .qa-lightbox{
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,.88);
        z-index: 3000;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: zoom-out;
    }
    .qa-lightbox img{
        max-width: 90%;
        max-height: 90%;
        border-radius: 8px;
        box-shadow: 0 10px 50px rgba(0,0,0,.6);
    }
    .qa-lightbox-close{
        position: absolute;
        top: 30px;
        right: 56px;
        font-size: 60px;
        color: #fff;
        cursor: pointer;
        line-height: 1;
    }
    .qa-lightbox-tip{
        position: absolute;
        bottom: 30px;
        color: rgba(255,255,255,.6);
        font-size: 24px;
    }
}
</style>
